import React, { PureComponent } from 'react';

import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import Div100vh from 'react-div-100vh'

import { zIndexes } from 'style';
import { Media } from '..';

class HeroImage extends PureComponent {
    render() {
        const {
            image,
            showFullscreenControl,
            showMuteControl,
            teaserImageWide,
            loop = true,
            fadein = true,
            heroOnLoad,
        } = this.props;
        return (
            <HeroImageContainer>
                <HeroImageWrapper id="HeroImage" fadein={fadein}>
                    <Media
                        image={image}
                        loop={loop}
                        visible={true}
                        onLoad={heroOnLoad}
                        showFullscreenControl={showFullscreenControl}
                        showMuteControl={showMuteControl}
                    />
                    {/* <Media image={teaserImageWide} loop={false} /> */}
                </HeroImageWrapper>
            </HeroImageContainer>
        );
    }
}

const HeroImageWrapperAnim = keyframes`
0%{
  opacity: 0;
}
100%{
  opacity: 1;
}
`;

const HeroImageContainer = styled(Div100vh)`
    position: relative;
    width: 100%;
`;
const HeroImageWrapper = styled.div`
    overflow: hidden;

    opacity: ${props => (props.fadein ? 0 : 1)};
    animation: ${props => (props.fadein ? HeroImageWrapperAnim : '')} 1s
        forwards;

    z-index: ${zIndexes.zHero};

    &::before {
        // content: '';
        width: 1px;
        margin-left: -1px;
        float: left;
        height: 0;
        // padding-top: 66.66666666%;
    }

    &::after {
        content: '';
        display: table;
        clear: both;
    }

    .gatsby-image-outer-wrapper {
        height: 100%;
    }
    .gatsby-image-wrapper {
        height: 100%;
    }

    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;

    .react-player {
        width: 100%;
        height: 100%;
    }
    video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-width: 101%;
        min-height: 101%;
        max-width: initial;
        opacity: 1;
        width: auto !important;
        height: auto !important;
        z-index: 1;
    }
`;

export default HeroImage;
